import React from 'react';
import defaultLoadingGif from '../../assets/gifs/scale_loading.gif';

const LoadingSpinner = ({
  message = "",
  showDefaultText = true,
  defaultText = "Data is loading...",
  size = "large",
  gifUrl = defaultLoadingGif
}) => {
  
  const sizeClasses = {
    small: "h-24 w-24",
    medium: "h-32 w-32", 
    large: "h-80 w-80"
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="text-center">
        {(message || showDefaultText) && (
          <p className="text-gray-600">
            {message || defaultText}
          </p>
        )}
        <img 
          src={gifUrl} 
          alt="Loading" 
          className={`${sizeClasses[size]} mx-auto mb-4 object-contain`}
        />
      </div>
    </div>
  );
};

export default LoadingSpinner;
